import localforage from "localforage";

export const localStorage = localforage.createInstance({
  driver: localforage.LOCALSTORAGE,
});

export default localStorage;
